import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CellcomAbroadLobbyBlockData from '../../../Models/Content/CellcomAbroadLobbyBlockData';
import './cellcomAbroad.scss';
import CellcomAbroadMain from './cellcomAbroadMain';

export default class CellcomAbroadLobbyBlock extends EpiComponent<CellcomAbroadLobbyBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <CellcomAbroadMain iContent={this.props.data} context={this.getContext()} />;
  }
}
